/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ReassignIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <polyline points="19 15.5 22 18.5 19 21.5 19 21.5" />
      <path d="M21.65,18.5 L15.35,18.5" />
      <polyline points="13.998 13.441 11 12.367 11 10.322" />
      <path d="M7,10.323 L7,12.367 L3.059,13.779 C2.115,14.117 1.5,15.012 1.5,16.012 L1.5,17.5 L12,17.5" />
      <path d="M12.947,6.236 C12.947,8.854 11.179,10.977 9,10.977 C6.819,10.977 5.053,8.854 5.053,6.236 C5.053,3.621 6.819,1.5 9,1.5 C11.18,1.5 12.947,3.621 12.947,6.236 Z" />
      <path d="M12.916,5.811 C12.784,5.829 12.675,5.817 12.542,5.844 C11.197,6.102 10.334,5.615 9.593,4.319 C9.149,5.17 7.762,5.844 6.621,5.844 C6.059,5.844 5.576,5.729 5.093,5.475" />
      <path d="M15.5,1.5 C17.68,1.5 19.447,3.621 19.447,6.236 C19.447,8.854 17.679,10.977 15.5,10.977" />
      <path d="M19.416,5.811 C19.284,5.829 19.175,5.817 19.042,5.844 C17.697,6.102 16.834,5.615 16.093,4.319" />
      <path d="M17.5,12 L17.5,10.322" />
    </g>
  </svg>
);

export default ReassignIcon;
